var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPurchaseCardLady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 527,
    viewBox: "0 0 340 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.964 62.9163C113.355 60.6346 112.541 58.3529 111.108 56.5602C99.4629 41.9086 122.052 30.2558 128.567 25.0242C135.375 19.5808 126.629 7.7161 141.401 2.0771C156.173 -3.56189 161.368 4.09801 162.068 3.82095C163.111 3.42981 160.847 18.4074 160.847 18.4074C160.847 18.4074 153.469 21.1291 154.235 36.1066C155 51.0842 159.283 58.7115 150.538 70.8696C141.792 83.0276 104.463 69.3702 104.463 69.3702C110.554 69.0605 112.476 65.801 112.964 62.9163Z",
    fill: "#673B25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.126 518.012C243.126 522.608 188.696 526.324 121.563 526.324C54.4299 526.324 0.000289917 522.608 0.000289917 518.012C0.000289917 513.416 54.4299 509.7 121.563 509.7C188.696 509.7 243.126 513.416 243.126 518.012Z",
    fill: "#E3E5EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.643 502.823C159.643 502.823 152.233 405.835 171.728 365.662L180.881 234.221L226.157 250.926L174.203 503.605L159.643 502.823Z",
    fill: "#E3633D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5469 504.746L91.6934 474.579L66.5306 467.75L60.7163 505.724L76.5469 504.746Z",
    fill: "#E3633D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.964 251.969L138.86 352.298C138.86 352.298 117.362 451.583 98.632 480.316L55.8798 481.212L88.1435 347.539L113.078 236.356L167.964 251.969Z",
    fill: "#6074B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.673 499.368L187.344 508.609C189.836 510.89 203.419 515.323 203.419 515.323C204.77 518.159 202.132 519.642 199.884 520.017L159.787 519.17C159.787 519.17 150.52 517.246 158.745 499.384C166.025 502.627 172.767 504.925 174.673 499.368Z",
    fill: "#4A2B1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9222 499.514L49.2513 508.755C46.7594 511.037 33.1764 515.47 33.1764 515.47C31.8246 518.306 34.4631 519.789 36.7106 520.164L76.8081 519.316C76.8081 519.316 86.0751 517.393 77.8504 499.531C70.5541 502.758 63.8277 505.072 61.9222 499.514Z",
    fill: "#4A2B1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.765 251.285L206.188 371.545L187.28 483.673H149.869C149.869 483.673 154.234 463.448 153.713 457.026C153.192 450.605 151.498 389.733 165.732 361.718L164.609 247.65L230.765 251.285Z",
    fill: "#6074B8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.406 361.718L164.282 247.65L186.448 248.873L184.64 316.264C184.787 331.828 183.403 353.553 179.559 368.921C171.986 399.316 163.598 458.184 162.328 463.334C158.012 480.658 171.709 483.673 171.709 483.673H149.543C149.543 483.673 153.908 463.448 153.387 457.026C152.865 450.605 151.172 389.733 165.406 361.718Z",
    fill: "#4B5C97"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.565 117.106C282.067 108.452 290.617 104.035 314.021 94.7946L328.093 104.932C283.907 130.503 280.357 141.422 258.631 141.927C243.272 124.668 253.598 120.317 258.565 117.106Z",
    fill: "#C95835"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.816 54.6045C197.816 54.6045 275.926 117.351 270.633 127.748L268.418 132.393C265.536 138.44 257.751 140.167 252.604 135.897L214.184 104.133L206.562 98.1356L197.816 54.6045Z",
    fill: "#C95835"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.015 157.557L222.246 164.206C236.431 169.422 230.764 251.285 230.764 251.285L173.402 253.941C146.758 253.387 115.227 274.297 111.921 229.87C108.126 179.07 135.015 157.557 135.015 157.557Z",
    fill: "#6074B8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.947 235.834C112.947 235.834 169.006 241.376 187.833 215.935L110.228 209.269C110.244 209.269 109.43 226.969 112.947 235.834Z",
    fill: "#4B5C97"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.149 53.5452L165.114 49.7967L156.335 50.1389L122.948 61.7918C111.71 67.3656 106.482 80.4363 110.782 92.2684L118.958 130.503C121.726 164.076 115.456 189.908 107.296 209.253C154.641 226.838 219.706 225.991 234.657 204.25C232.117 144.845 220.195 91.7958 197.149 53.5452Z",
    fill: "#A9BAE0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.88 32.9612C180.88 32.9612 179.202 45.5756 177.802 56.0387C177.427 58.8256 175.603 61.1887 173.03 62.2318C170.456 63.2748 167.509 62.8185 165.359 61.0583C164.658 60.4879 163.958 59.9175 163.307 59.3797C160.343 56.9513 159.023 53.0236 159.919 49.2751C162.215 39.6758 166.417 22.2047 166.417 22.2047L180.88 32.9612Z",
    fill: "#C95835"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.538 39.9039L178.958 47.4009L172.688 39.9039H180.538Z",
    fill: "#883C25"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M182.59 51.9316C182.59 51.9316 193.095 77.9426 175.245 79.0835C157.411 80.2243 147.64 53.2028 147.64 53.2028L160.669 47.4171L182.59 51.9316Z",
    fill: "#C95835"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.001 19.4178C158.812 15.8812 160.685 12.0512 164.17 10.8615C167.9 9.5903 172.59 7.97683 176.32 6.70561C179.805 5.51588 183.079 7.63458 184.789 10.943C186.809 14.8544 189.056 23.6226 189.936 30.1742C190.424 33.8738 188.796 37.9971 185.294 39.1869C181.564 40.4581 169.186 40.6862 165.848 34.2976C163.291 29.4409 161.744 24.6167 160.001 19.4178Z",
    fill: "#C95835"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.545 36.7097C149.545 36.7097 149.642 17.5599 154.203 11.3342C160.343 2.95723 169.561 -2.61657 181.89 4.65219C181.89 4.65219 177.525 20.1676 154.203 36.123L149.545 36.7097Z",
    fill: "#673B25"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.848 34.7703C162.753 37.166 165.864 37.8179 167.819 36.2371C169.773 34.6562 169.822 31.4292 167.916 29.0335C166.011 26.6377 162.9 25.9858 160.946 27.5667C158.991 29.1639 158.942 32.3908 160.848 34.7703Z",
    fill: "#C95835"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.606 28.0067L181.498 29.9624C181.498 29.9624 182.948 34.1509 185.765 32.8634C188.599 31.5596 187.606 28.0067 187.606 28.0067Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8989 152.651L132.068 101.509C141.693 91.9097 140.439 75.9706 129.43 68.0173C125.097 64.8882 119.039 65.8009 115.847 70.1034L72.4918 125.206L87.8989 152.651Z",
    fill: "#C95835"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5892 120.969C67.3613 127.765 62.8173 139.222 69.2668 151.918L112.752 206.205L119.869 193.575L94.169 148.039L77.5892 120.969Z",
    fill: "#C95835"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M119.803 193.672L121.481 206.238C121.823 208.748 121.237 211.29 119.852 213.425L114.25 222.014C112.295 225.013 107.963 225.127 105.846 222.242L104.624 206.336C104.347 202.832 105.487 199.116 107.768 195.922L111.595 190.625L119.803 193.672Z",
    fill: "#C95835"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M161.546 4.1468C161.546 4.1468 153.435 3.64158 151.79 15.1151",
    stroke: "#8B939C",
    strokeWidth: 0.905,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.86 91.9913L103.258 139.352L97.8671 147.061L112.867 178.45L96.7108 192.499L66.1246 154.574C66.1246 154.574 57.6882 139.026 69.7728 124.147C81.8575 109.267 114.707 68.2782 114.707 68.2782L135.717 60.9606L143.86 91.9913Z",
    fill: "#A9BAE0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.118 53.5615C197.118 53.5615 205.88 55.7128 221.499 69.6147C241.222 87.1999 270.766 117.774 273.225 124.065C275.684 130.356 243.127 133.176 243.127 133.176L208.111 102.96L197.118 53.5615Z",
    fill: "#A9BAE0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M116.921 122.175L130.781 103.498L129.771 97.174",
    stroke: "#5B74A4",
    strokeWidth: 1.863,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M220.928 116.454L208.273 87.819L208.208 81.9519",
    stroke: "#5B74A4",
    strokeWidth: 1.863,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M307.442 112.527L323.419 108.289C326.611 107.442 329.396 105.486 331.269 102.748L338.826 91.7144C341.465 87.8681 339.445 82.5714 334.901 81.4469L315.113 87.9007C310.748 89.3186 306.823 92.5293 304.136 96.8808L299.657 104.133L307.442 112.527Z",
    fill: "#C95835"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M243.126 133.192C243.126 133.192 256.399 152.097 272.083 146.149C287.767 140.2 313.858 116.471 313.858 116.471L295.487 96.4407L261.627 114.042L243.126 133.192Z",
    fill: "#A9BAE0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseCardLady);
export default __webpack_public_path__ + "static/media/PurchaseCardLady.59118767e77bbed35e94893d2eb13ff2.svg";
export { ForwardRef as ReactComponent };